import { defineComponent as _defineComponent } from 'vue'
import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import type { Anchor } from '@@/library/v4/components/OzBasePopover.vue'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzPopover from '@@/library/v4/components/OzPopover.vue'
import { flip, offset } from '@floating-ui/vue'

export interface Button {
  text: string
  ariaLabel: string
  icon: string
  action: () => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceAddPostMenu',
  props: {
    popoverAnchor: null,
    buttons: null
  },
  emits: ["close-menu"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'close-menu'): void
}), expose: any, slots: any, attrs: any }) {





function handleClick(action: () => void): void {
  action()
  emit('close-menu')
}

return { __sfc: true,emit, handleClick, OzBaseButton, OzBox, OzBoxColors, OzIcon, OzPopover, flip, offset }
}

})